export type AiSummaryBlock = {
    type: 'section' | 'list' | 'paragraph';
    title?: string;
    content: string;
    isLongList?: boolean;
};

export function parseAiSummaryBlocks(aiResult: string | null): AiSummaryBlock[] {
    if (!aiResult || typeof aiResult !== 'string') return [];

    const raw = aiResult.trim();
    const lines = raw.split(/\r?\n/);
    const blocks: AiSummaryBlock[] = [];
    let i = 0;
    const recommendedIdsStart = lines.findIndex((l) => /^\s*RECOMMENDED_ROOF_IDS:/i.test(l));
    const endIndex = recommendedIdsStart >= 0 ? recommendedIdsStart : lines.length;
    const recommendedSection =
        recommendedIdsStart >= 0
            ? lines
                  .slice(recommendedIdsStart)
                  .filter((l) => l.trim())
                  .join('\n')
            : '';

    while (i < endIndex) {
        const line = lines[i];
        const trimmed = line.trim();
        if (!trimmed) {
            i++;
            continue;
        }

        const numberedMatch = trimmed.match(/^(\d+)\.\s+(.+)/);
        if (numberedMatch) {
            const sectionLines: string[] = [trimmed];
            i++;
            while (i < endIndex && lines[i]?.trim() && !/^\d+\.\s+/.test(lines[i])) {
                sectionLines.push(lines[i]);
                i++;
            }
            const content = sectionLines.join('\n');
            const listLikeLines = sectionLines.filter((l) => /^\s*[-*•]\s+/.test(l) || /^\s*\d+[.)]\s+/.test(l) || /^\s*[-*•]/.test(l));
            const isLongList = listLikeLines.length > 5;
            blocks.push({
                type: isLongList ? 'list' : 'section',
                title: numberedMatch[1] + '. ' + numberedMatch[2].replace(/:$/, '').slice(0, 60) + (numberedMatch[2].length > 60 ? '…' : ''),
                content,
                isLongList,
            });
            continue;
        }

        const bulletMatch = trimmed.match(/^[-*•]\s+(.+)/);
        if (bulletMatch) {
            const listLines: string[] = [];
            while (i < endIndex && (lines[i]?.trim().match(/^[-*•]\s+/) || lines[i]?.trim().match(/^\d+[.)]\s+/))) {
                listLines.push(lines[i].trim());
                i++;
            }
            if (listLines.length === 0) listLines.push(trimmed);
            const content = listLines.join('\n');
            blocks.push({ type: 'list', content, isLongList: listLines.length > 5 });
            continue;
        }

        const paraLines: string[] = [trimmed];
        i++;
        while (i < endIndex && lines[i]?.trim() && !/^\d+\.\s+/.test(lines[i]) && !/^[-*•]\s+/.test(lines[i])) {
            paraLines.push(lines[i]);
            i++;
        }
        blocks.push({ type: 'paragraph', content: paraLines.join('\n') });
    }

    if (recommendedSection) {
        blocks.push({ type: 'paragraph', content: recommendedSection });
    }

    return blocks;
}

